module.exports = __webpack_public_path__ + "img/16_25.eeee4544.png";